import {useMemo} from 'react'
import {ActionState, PlayerColor} from '@colonist/game-states'
import {useGameStore} from '../../store/GameStoreContext'
import {useCurrentStateValidator} from '../../store/selectors/useCurrentStateValidator'
import {TranslationKeys, TranslationObject} from '@colonist/i18n'
import {EnumUtils} from '@colonist/utils'
import {CurrentStateMessageUtils} from '../UIGameCurrentStatus/CurrentStateMessageUtils'

export const usePlayerStatus = (playerColor: PlayerColor) => {
    const currentStateValidator = useCurrentStateValidator()
    const myPlayerColor = useGameStore((state) => state.myColor)
    const playerActionState = currentStateValidator.getPlayerActionState(playerColor)
    const isMyPlayer = playerColor === myPlayerColor

    return useMemo<TranslationObject>(() => {
        const perspectiveKey: 'self' | 'other' = isMyPlayer ? 'self' : 'other'
        const effectiveActionState = !isMyPlayer && CurrentStateMessageUtils.isActionStateHiddenFromOpponents(playerActionState)
            ? ActionState.None
            : playerActionState
        const actionStateKey = EnumUtils.getEnumKey(effectiveActionState, ActionState)
        const translationKey: TranslationKeys = `strings:game.playerInformation.playerStatus.${actionStateKey}.${perspectiveKey}`
        return {key: translationKey}
    }, [playerActionState, isMyPlayer])
}
